import update from 'immutability-helper';

import * as types from './constants';

const emptyState = {
  items: [
    {name: '', quantity: '', placeholder: 'ex: chips', autofocus: true},
    {name: '', quantity: '', placeholder: 'ex: salsa'},
    {name: '', quantity: '', placeholder: 'ex: drinks'},
    {name: '', quantity: '', placeholder: 'ex: cups'}
  ],
  editing: true,
  allow_other_items: false,
};

const initialState = window.initial_what_to_bring_data ?
                      window.initial_what_to_bring_data : emptyState;

function whatToBringReducer(state=initialState, action) {
  switch (action.type) {
    case types.UPDATE_WHAT_TO_BRING:
      return update(state, {$set: action.whatToBring});
    case types.UPDATE_ITEM_NAME:
      return update(state, {
        items: {
          [action.index]: {
            name: {$set: action.value}
          }
        }
      });
    case types.UPDATE_ITEM_QTY:
      return update(state, {
        items: {
          [action.index]: {
            quantity: {$set: action.value}
          }
        }
      });
    case types.ADD_ITEM:
      return update(state, {
        items: {$push: [{
            name: '',
            quantity: '',
            autofocus: true
          }]
        }
      });
    case types.REMOVE_ITEM:
      const filtered = state.items.filter(function(item, i) {
        return i !== action.index;
      });
      return update(state, {
        items: {$set: filtered}
      });
    case types.TOGGLE_EDIT:
      const editing = state.editing;
      return update(state, {
        editing: {$set: !editing}
      });
    case types.TOGGLE_ALLOW:
      const allow_other_items = state.allow_other_items;
      return update(state, {
        allow_other_items: {$set: !allow_other_items}
      });
    case types.DELETE_WHAT_TO_BRING:
      return emptyState;
    case types.UPDATE_OTHER_NAME:
        return update(state, {
          items: {
            ['other']: {
              name: {$set: action.value }
            }
          }
        });
    case types.UPDATE_OTHER_QTY:
      return update(state, {
        items: {
          ['other']: {
            quantity: {$set: action.value}
          }
        }
      });
    case types.CANCEL_OTHER:
      return update(state, {

      })

    default:
      return state;
  }
}

export default whatToBringReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/what-to-bring/reducers.es6